import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

export const builds = (store) => store.apps.jobs.flatBuilds.vdc;

export const automatedBuildsSelector = createSelector([
  (store) => store.apps.jobs.flatBuilds.common,
  builds,
  eventMetaDataSelector,
],
(common, vdc, eventMetaData) => ({
  buildsLoading: common.get('vdcBuildsLoading'),
  builds: vdc.get('builds'),
  expandedBuilds: vdc.get('expandedBuilds'),
  failedJobs: vdc.get('failedJobs'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'VDC',
  },
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(builds);
